<template>
  <div class="searchSuppliesPage" v-if="!this.showLoad">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入申请人姓名"
      show-action
      shape="round"
      @search="onSearch"
      @input="onSearch"
    ></van-search>
    <div class="list-content" id="list-content">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            :title="`${
              item.applicantName + ' - ' + item.createTime.substr(0, 10)
            }`"
            clickable
            v-for="item in itemMainList"
            :key="item.id"
            @click="selectitem(item)"
          >
            <van-radio slot="right-icon" :name="`${item.id}`" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="nonePage" v-if="itemMainList.length == '0' && refreshing">
      <img :src="baseUrl + 'empty.png'" alt />
      <p>暂无数据</p>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
import { dateFormat, getDictList } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";

export default {
  name: "searchSupplies",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      commonId: "",
      radio: "", //选中的项目
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      itemMainList: [],
      selecItemList: [],
      selecData: "",
      refreshing: false,
      clientType: "", //手机类型
    };
  },
  mounted() {
    this.setShowLoad(false); //加载状态，默认为true加载
    this.commonId = this.$route.query.commonId; //申请Id

    this.getTest();
  },
  methods: {
    ...mapMutations(["setShowLoad", "setAppData"]),
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getTest() {
      let _this = this;
      // console.log(_this.commonId);
      if (
        _this.commonId == undefined ||
        _this.commonId == "" ||
        _this.commonId == null ||
        _this.commonId == "null"
      ) {
        _this.commonId = "";
      }

      _this.$api.material.procurementManage
        .materialRegisterList(_this.commonId)
        .then((res) => {
          if ((res.code == "1") & (res.data != null)) {
            _this.selecItemList = res.data;
            _this.viewLists();
            _this.refreshing = true;
            // 加载状态结束
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewLists() {
      this.itemMainList = this.selecItemList;
    },
    selectitem(item) {
      let _this = this;
      console.log(_this.selecData);
      if (_this.selecData.id && _this.selecData.applicantName) {
        if (_this.selecData.id == item.id) {
          _this.radio = "";
          _this.selecData = "";
        } else {
          _this.radio = item.id;
          _this.selecData = item;
        }
      } else {
        _this.radio = item.id;
        _this.selecData = item;
      }
    },
    closeRetinuePicker() {
      this.selecData = "";
      this.$emit("setItems", "");
    },
    saveRetinue() {
      let _this = this;
      this.$emit("setItems", _this.selecData);
    },

    reloadPage() {
      let _this = this;
      if (_this.searchName) {
        _this.itemMainList = [];
        _this.selecItemList.forEach((item) => {
          if (item.applicantName.includes(_this.searchName)) {
            _this.itemMainList.push(item);
          }
        });
        console.log(_this.itemMainList);
      } else {
        _this.itemMainList = this.selecItemList;
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less" >
.searchSuppliesPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    overflow: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 135px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -67px;
    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    border-top: 1px solid #f6f6f6;
    bottom: 0;
    background-color: #fff;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>